<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4">
      <input
        type="checkbox"
        :value="contact.id"
        :disabled="maxSelectedReachedAndNotSelected"
        v-model="selectedContactIds"
      />
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <a role="button" class="underline" @click.prevent="showContact">
        {{ fullName }}
      </a>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ concatenatedEmailAddresses }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ concatenatedPhoneNumbers }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <span class="whitespace-nowrap">
        {{ createdAtShort }}
      </span>
      <p>
        {{ createdAtFromNow }}
      </p>
    </td>
  </tr>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  computed: {
    selectedContactIds: {
      get() {
        return this.$store.getters?.[`${this.contact.accountId}:contactMerge/selectedContactIds`];
      },
      set(contactIds) {
        this.$store.commit(
          `${this.contact.accountId}:contactMerge/setSelectedContactIds`,
          contactIds
        );
      },
    },
    maxSelectedReachedAndNotSelected() {
      if (this.selectedContactIds.length < 3) {
        return false;
      }

      return this.selectedContactIds.indexOf(this.contact.id) === -1;
    },
    fullName() {
      if (typeof this.contact?.fullName === 'string') {
        return this.contact.fullName;
      }

      return `${this.contact?.firstName || ''} ${this.contact?.lastName || ''}`.trim();
    },
    emailAddresses() {
      return (this.contact?.emailAddresses || [])
        .map((emailAddressId) => this.$store.state.entities.emailAddresses.byId[emailAddressId])
        .filter(Boolean);
    },
    concatenatedEmailAddresses() {
      return this.emailAddresses.map(({ address }) => address).join(', ');
    },
    phoneNumbers() {
      return (this.contact?.phoneNumbers || [])
        .map((phoneNumberId) => this.$store.state.entities.phoneNumbers.byId[phoneNumberId])
        .filter(Boolean);
    },
    concatenatedPhoneNumbers() {
      return this.phoneNumbers.map(({ number }) => number).join(', ');
    },
    createdAt() {
      return moment.utc(this.contact.createdAt).local();
    },
    createdAtShort() {
      return this.createdAt.format('DD-MM-YYYY');
    },
    createdAtFromNow() {
      return this.createdAt.fromNow();
    },
  },
  methods: {
    showContact() {
      this.$modal.show({
        component: 'ContactModal',
        props: {
          contactId: this.contact.id,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
  },
};
</script>
